/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS � 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import qs from 'query-string'

import Request from 'generic/request/Request'

const INVITATIONS_URL = '/api/invitation/list/?meta=false&objects_count=false'
const INVITATION_ACTION_URL = '/api/invitation/action/'

export const getInvitations = (prestation) => {
  const query = {
    prestation: prestation.uid,
    bo_relations: 'interpreter.identities',
    sent_date: true,
  }

  return Request.getRequest(INVITATIONS_URL + '&' + qs.stringify(query))
    .then((results) => {
      return results.data.objects.objects
    })
}

export function getInvitationAction(token) {
  return Request.getRequest(INVITATION_ACTION_URL + token + '/')
    .catch((error) => {
      throw error.response
    })
}

export function postInvitationAction(token) {
  return Request.postRequest(INVITATION_ACTION_URL + token + '/', {})
    .catch((error) => {
      throw error.response
    })
}



// WEBPACK FOOTER //
// ./src/actions/Invitation.js